/*
 * Rubato journal.
 *
 * The masthead is set at a fixed cap height, so a long word can be wider than the
 * column at 390 and the browser breaks it mid word. This measures the widest word
 * and steps the size down until it fits, never above the size the CSS asked for.
 *
 * The step-down stops at 32px. A word that still does not fit at 32 is hyphenated
 * rather than shrunk any further, which is why the class is only set in that case:
 * hyphens: auto left on everywhere would hyphenate titles that wrap perfectly well
 * at their spaces.
 */

const FLOOR = 32;
const HYPHENATE = 'rubato-masthead__title--hyphenate';

function fitMasthead(title) {
  const styles = getComputedStyle(title);
  const target = parseFloat(title.dataset.rubatoMastheadSize || styles.fontSize);
  if (!target) return;

  title.dataset.rubatoMastheadSize = String(target);

  const available = title.clientWidth - parseFloat(styles.paddingInlineStart) - parseFloat(styles.paddingInlineEnd);
  if (!available) return;

  const canvas = (fitMasthead.canvas ??= document.createElement('canvas'));
  const context = canvas.getContext('2d');
  if (!context) return;

  const words = (title.textContent || '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return;

  let size = target;
  let widest = Infinity;
  while (size >= FLOOR) {
    context.font = `${size}px ${styles.fontFamily}`;
    widest = Math.max(...words.map((word) => context.measureText(word).width));
    if (widest <= available || size === FLOOR) break;
    size -= 1;
  }

  title.style.fontSize = size < target ? `${size}px` : '';
  title.classList.toggle(HYPHENATE, widest > available);
}

function fitAll() {
  for (const title of document.querySelectorAll('.rubato-masthead__title')) fitMasthead(title);
}

if (document.fonts?.ready) {
  document.fonts.ready.then(fitAll);
} else {
  fitAll();
}

window.addEventListener('resize', () => requestAnimationFrame(fitAll));
